// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"a8dc8fa4","421":"7a7e0898","583":"cc1c539e","601":"57aa5148","808":"cc66feda","891":"111d4d4f","918":"e77261ad"}[chunkId] + ".chunk.js";
};